import { z } from 'zod';

export const FeatureSettingSchema = z.object({
  enabled: z.boolean(),
});

// TypeScript Interfaces
export type FeatureSettingResponse = z.infer<typeof FeatureSettingSchema>;
